import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useEffect } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box, Stack } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { CloudflareConnectorModel } from '@/lib/models/connector/cloudflare-connector.model';
import Text from '@/components/text';
import TextInput from '@/components/form/text-input';
import NoneChip from '@/components/chip/none-chip';
import ConnectorStepCard from './connector-step-card';

interface Props {
  connector: CloudflareConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const CloudflareConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;
  const { connectorId, catalogUrl } = connector.config;

  const { setFieldValue } = formHandle;

  // manually update a field value so the form is marked as dirty and can be submitted
  useEffect(() => {
    if (isNew) {
      setFieldValue('config.orgAuthEnabled', true);
    }
  }, [setFieldValue, isNew]);

  return (
    <>
      {inWriteMode && (
        <Box>
          <InputControl
            name="config.authenticationType"
            label="Authentication Type"
            formHandle={formHandle}
            type="proxy-auth-type-select"
          />

          <InputControl
            name="config.xAuthenticatedUserEnabled"
            label="Enable X-Authenticated-User Header"
            formHandle={formHandle}
            type="switch"
          />
        </Box>
      )}

      {!inWriteMode && (
        <Box mt={2}>
          <ConnectorStepCard title="Deployment">
            <Stack gap={2}>
              <Text bold>Connector ID</Text>
              {connectorId ? (
                <TextInput
                  name="connectorId"
                  disabled
                  copyClip
                  value={connectorId}
                  fullWidth
                  size="x-small"
                />
              ) : (
                <NoneChip />
              )}

              <Text bold>Catalog URL</Text>
              {catalogUrl ? (
                <TextInput
                  name="catalogUrl"
                  disabled
                  copyClip
                  value={catalogUrl}
                  fullWidth
                  size="x-small"
                />
              ) : (
                <NoneChip />
              )}
            </Stack>
          </ConnectorStepCard>
        </Box>
      )}
    </>
  );
};

export default CloudflareConnector;
